import { getCookie, setCookie } from '@jspartials/cookie-utils';

// Selectors
const selector = {
  vtoButtonPdp: '.hw-virtual-try-on-open-button',
  vtoButtonTile: '.js-product-tile__vto-button'
};

// Variables
const experimentCookieName = 'e_seg_vto';
const controlSegmentName = 'A';
const experimentSegmentName = 'B';

// Functions

/**
 * Get the cookie value for the VTO experiment
 * @returns {String} - The cookie value
 */
const getCookieValue = () => getCookie(experimentCookieName);

/**
 * Get the VTO buttons in the product detail page
 * @returns {NodeList} - The VTO buttons in the product detail page
 */
const getVtoButtonsInPdp = () =>
  document.querySelectorAll(selector.vtoButtonPdp);

/**
 * Create a cookie for the VTO experiment
 * @returns {void}
 */
const createCookieForVtoExperiment = () => {
  let cookieValue = getCookieValue();

  if (!cookieValue) {
    if (Math.random() >= 0.5) {
      setCookie(experimentCookieName, controlSegmentName);
    } else {
      setCookie(experimentCookieName, experimentSegmentName);
    }
  }
};

/**
 * Hide VTO buttons in all product tiles
 * @returns {void}
 */
const hideVtoInProductTiles = () => {
  if (document.getElementById('vto-tile-hidden')) return;
  const style = document.createElement('style');
  style.id = 'vto-tile-hidden';
  style.textContent = `${selector.vtoButtonTile} { display: none !important; }`;
  document.head.appendChild(style);
};

/**
 * Hide VTO filters in all product listing pages
 * @returns {void}
 */
const hideVtoFiltersInPLP = () => {
  if (document.getElementById('vto-filter-hidden')) return;
  const style = document.createElement('style');
  style.id = 'vto-filter-hidden';
  style.textContent = `label[for='toggle_Yes'], .refinement-prueba-virtual, .js-apply-filters[data-id='hk_hasVirtualTryOn'] { display: none !important; }`;
  document.head.appendChild(style);
};

/**
 * Remove VTO buttons from product detail page
 * @returns {void}
 */
const removeVtoButtonsInPdp = () => {
  const cookieValue = getCookieValue();
  const vtoButtonsPdp = getVtoButtonsInPdp();

  if (cookieValue === experimentSegmentName) {
    vtoButtonsPdp.forEach((vtoButton) => vtoButton.remove());
  }
};

/**
 * Initialize the VTO experiment
 * @returns {void}
 */
const initVtoExperiment = () => {
  createCookieForVtoExperiment();

  hideVtoInProductTiles();
  hideVtoFiltersInPLP();

  if (getCookieValue() === experimentSegmentName) {
    removeVtoButtonsInPdp();
  }
};

// Initialize the script when the DOM is fully loaded
document.addEventListener('DOMContentLoaded', function () {
  initVtoExperiment();
});

// Listen for updates to the product detail page content
document.addEventListener('afterUpdateContentOfProductDetailPage', function () {
  initVtoExperiment();
});
